import { Spacer } from '@nextui-org/react';

export default Spacer;
